export default __webpack_public_path__ + "static/media/manai.3fef9a41.jpg";